module.exports = __webpack_public_path__ + "img/hr-rock-big-17.70096565.png";